export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/hubWhiteBG.054ab069.svg","height":26,"width":27,"blurWidth":0,"blurHeight":0};